// ─────────────────────────────────────────────────────────────────────────── //
//                         RECEPTION OPENING EVENTS                           //
//                              Kiosk → Galadrim                              //
// ─────────────────────────────────────────────────────────────────────────── //

export const RECEPTION_OPENING_EVENT_TYPES = {
  METHOD_SELECTED: 'method.selected',
  METHOD_VERIFIED: 'method.verified',
  OPENING_REPORT: 'opening.report',
} as const

// ─── Methods ─────────────────────────────────────────────────────────────── //

export const METHOD = {
  ACCOUNT: 'account',
  CARD: 'card',
  PREAUTHORIZATION: 'preAuthorization',
} as const

// ─────────────────────────────────────────────────────────────────────────── //
//                          EMISSION OPENING EVENTS                           //
//                              Galadrim → Kiosk                              //
// ─────────────────────────────────────────────────────────────────────────── //

export const EMISSION_OPENING_EVENT_TYPES = {
  METHOD_CONFIRM: 'method.confirm',
  OPENING_CONFIRM: 'opening.confirm',
} as const

// ─────────────────────────────────────────────────────────────────────────── //
//                            OPENING EVENT STATUS                             //
// ─────────────────────────────────────────────────────────────────────────── //

export const OPENING_EVENT_STATUS = {
  PENDING: 'pending',
  DONE: 'done',
  TIMEDOUT: 'timedout',
} as const

export type OpeningEventStatus = (typeof OPENING_EVENT_STATUS)[keyof typeof OPENING_EVENT_STATUS]

export type OpeningEventType =
  | (typeof RECEPTION_OPENING_EVENT_TYPES)[keyof typeof RECEPTION_OPENING_EVENT_TYPES]
  | (typeof EMISSION_OPENING_EVENT_TYPES)[keyof typeof EMISSION_OPENING_EVENT_TYPES]

export type OpeningEventMethod = (typeof METHOD)[keyof typeof METHOD]

// ─────────────────────────────────────────────────────────────────────────── //
//                           OPENING EVENT DB TYPE                             //
// ─────────────────────────────────────────────────────────────────────────── //

export interface OpeningEvent {
  id: number
  kioskId: number
  type: OpeningEventType
  method: OpeningEventMethod
  status: OpeningEventStatus
  valid: boolean | null
  accountId: number | null
  preAuthorizationId: string | null
  preAuthorizationAmount: number | null
  contactless: boolean | null
  timeout: number | null
  granted: boolean | null
  manual: boolean | null
  receivedAt: string
  createdAt: string
  updatedAt: string
}
